const THEME = Symbol.for('k-theme');
const LOCAL_STORAGE_KEY = 'k-theme';

export { LOCAL_STORAGE_KEY, THEME };
